import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [isNoBuildingsScreen, setIsNoBuildingsScreen] = useState(false);

  return (
    <AppContext.Provider value={{ isNoBuildingsScreen, setIsNoBuildingsScreen }}>
      {children}
    </AppContext.Provider>
  );
};


export const useAppContext = () => useContext(AppContext);